import { Box, styled, Typography, useTheme } from "@mui/material";
import { useFormikContext } from "formik";
import { formatPrice } from "helpers";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import shortid from "shortid";
import chortkeLogo from "assets/images/logo_blue.png";
import DefaultPrintLogo from "assets/svg/DefaultPrintLogo.svg";
import { Logo, LowerSection } from "./components";
import { invoiceInitialValues } from "store/reducers/factorReducer";
import Table from "components/Table2";
import Text from "components/Table2/CellComps/Text";
import Price from "components/Table2/CellComps/Price";
// @ts-ignore

const HeaderImage = styled("div")(
    ({ theme, backgroundImage }: { theme: ThemeObjType; backgroundImage: string }) => ({
        backgroundImage: `url("${backgroundImage}")`,
        height: "50px",
        backgroundSize: "100% 100%",
    })
);
const TitleSection = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    height: "100%",
    flexDirection: "column",
}));
const TitleDetails = styled("div")(({ theme }) => ({
    display: "grid",
    justifyContent: "space-between",
    gridTemplateColumns: "25% 25% 25%",
}));
const TitleUpperSection = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "12px 0 32px 0",
}));
const TitleLeftSection = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));
const TitleItem = styled("div")(({ theme }) => ({
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
}));

const RowItem = styled("div")(({ theme, items }: { theme: ThemeObjType; items?: number }) => {
    let initialWidth = 96;
    // @ts-ignore
    if (items > 0) initialWidth = Math.floor(96 / items);
    return {
        display: "grid",
        //   height: "140px",
        gridTemplateColumns: `repeat(auto-fill, ${initialWidth}%)`,
        marginBottom: "20px",
    };
});

const SignContainer = styled("div")(({ theme }) => ({
    display: "grid",
    height: "100px",
    gridTemplateColumns: "50% 50%",
}));
const SignComponent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center",
    height: "100%",
    width: "100%",
    gridTemplateColumns: "50% 50%",
}));
const BodyComponent = styled("div")(
    ({
        theme,
        backgroundImage,
        backgroundColor,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        borderColor,
        borderSize,
    }: {
        theme: ThemeObjType;
        backgroundImage: string;
        backgroundColor: string;
        paddingTop: number;
        paddingRight: number;
        paddingBottom: number;
        paddingLeft: number;
        borderColor: string;
        borderSize: number;
    }) => ({
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: "100% 100%",
        // page:`size: A4; background-size: cover; background: url('${backgroundImage}') no-repeat center center;`,
        // // backgroundImage: `url("${backgroundImage}")`,
        // // backgroundSize: "100% 100%",
        // // height: "275mm",
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft,
        borderStyle: "solid",
        borderColor: borderColor,
        borderWidth: borderSize,
        backgroundColor: backgroundColor,
        borderRadius: theme.shape.borderRadius,
        position: "relative"
    })
);

const MiddleItem = styled("div")(({ theme }) => ({
    display: "flex",
    //   paddingRight: "70px",
    //   paddingTop: "20px",
    flexDirection: "column",
    //   justifyContent: "space-between",
}));

const DetailsTextItem = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginTop: "16px",
}));
const InvoiceTag = styled("div")(({ theme }) => ({
    width: "100%",
    height: "40px",
    backgroundColor: "#e0e0e050",
    color: "#777",
    padding: "4px 32px",
    // backgroundImage: `url("/assets/images/invoiceTag.jpg")`,
    // backgroundSize: "100% 100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));

export const generateRgb = (color: any) => {
    const rgb = `rgba(${color?.r},${color?.g},${color?.b}, ${color?.a})`;
    return rgb;
};

const InvoiceDetail = ({
    data,
    values,
    order,
}: {
    data: any;
    values: typeof invoiceInitialValues;
    order: string;
}) => {
    const { showAccountingCode, showDate, showTime, showDueDate, showReference } = values;
    const { invoiceHeaderSize, invoiceBodySize, invoiceHeaderColor, invoiceBodyColor } = values;
    const theme = useTheme();

    function timeNow() {
        const d = new Date(),
            h = (d.getHours() < 10 ? "0" : "") + d.getHours(),
            m = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes(),
            s = (d.getSeconds() < 10 ? "0" : "") + d.getSeconds();
        return h + ":" + m + ":" + s;
    }


    return (
        <TitleSection>
            <MiddleItem>
                {showAccountingCode && (
                    <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                        <Typography
                            variant="body2"
                            color={generateRgb(invoiceHeaderColor)}
                            fontSize={invoiceHeaderSize}
                            fontWeight="bold"
                        >
                            شماره فاکتور:&nbsp;
                        </Typography>
                        <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="h6">
                            {data?.accountingCode}
                        </Typography>
                    </DetailsTextItem>
                )}
                {showDate && (
                    <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                        <Typography
                            variant="body2"
                            color={generateRgb(invoiceHeaderColor)}
                            fontSize={invoiceHeaderSize}
                            fontWeight="bold"
                            className="whitespace-nowrap"
                        >
                            {showDueDate ? "تاریخ صدور" : "تاریخ"}:&nbsp;
                        </Typography>
                        <Typography
                            color={generateRgb(invoiceBodyColor)}
                            fontSize={invoiceBodySize}
                            variant="body2"
                            style={{ direction: "ltr", zIndex: 2 }}
                        >
                            {data?.date}
                        </Typography>
                    </DetailsTextItem>
                )}
                {showTime && (
                    <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                        <Typography
                            variant="body2"
                            color={generateRgb(invoiceHeaderColor)}
                            fontSize={invoiceHeaderSize}
                            fontWeight="bold"
                        >
                            {showDueDate ? "ساعت صدور" : "ساعت"}:&nbsp;
                        </Typography>
                        <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="body2">
                            {data?.time}
                        </Typography>
                    </DetailsTextItem>
                )}
                {showDueDate && (
                    <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                        <Typography
                            variant="body2"
                            color={generateRgb(invoiceHeaderColor)}
                            fontSize={invoiceHeaderSize}
                            fontWeight="bold"
                        >
                            تاریخ سررسید:&nbsp;
                        </Typography>
                        <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="body2">
                            {data?.dueDate}
                        </Typography>
                    </DetailsTextItem>
                )}
                {showReference && (
                    <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                        <Typography
                            variant="body2"
                            color={generateRgb(invoiceHeaderColor)}
                            fontSize={invoiceHeaderSize}
                            fontWeight="bold"
                        >
                            ارجاع:&nbsp;
                        </Typography>
                        <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="body2">
                            {data?.reference}
                        </Typography>
                    </DetailsTextItem>
                )}
            </MiddleItem>
        </TitleSection>
    );
};

const CustomerDetails = ({
    data,
    values,
    order,
}: {
    data: any;
    values: typeof invoiceInitialValues;
    order: string;
}) => {
    const {
        cutomerBusinessName,
        cutomerBusinessNameActive,
        customerAddress,
        customerAddressActive,
        customerTelephone,
        customerTelephoneActive,
        customerMobile
    } = values;
    const { invoiceHeaderSize, invoiceBodySize, invoiceHeaderColor, invoiceBodyColor } = values;
    const theme = useTheme();
    return (
        <MiddleItem>
            {cutomerBusinessNameActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                        fontWeight="bold"
                    >
                        {cutomerBusinessName}:&nbsp;
                    </Typography>
                    <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="h6">
                        {data.name}
                    </Typography>
                </DetailsTextItem>
            )}
            {customerAddressActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                        fontWeight="bold"
                    >
                        {customerAddress}:&nbsp;
                    </Typography>
                    <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="body2">
                        {data.address}
                    </Typography>
                </DetailsTextItem>
            )}
            {customerTelephoneActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                        fontWeight="bold"
                    >
                        {customerTelephone}:&nbsp;
                    </Typography>
                    <Typography color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize} variant="body2">
                        {data.phone}
                    </Typography>
                </DetailsTextItem>
            )}
            {customerMobile && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                        fontWeight="bold"
                    >
                        همراه:&nbsp;
                    </Typography>
                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                        {data.mobile}
                    </Typography>
                </DetailsTextItem>

            )}
        </MiddleItem>
    );
};

const SellerDetails = ({
    data,
    values,
    order,
}: {
    data: any;
    values: typeof invoiceInitialValues;
    order: string;
}) => {
    const { businessName, businessNameActive, address, addressActive, telephone, telephoneActive } = values;
    const { invoiceHeaderSize, invoiceBodySize, invoiceHeaderColor, invoiceBodyColor, mobile } = values;
    const theme = useTheme();
    return (
        <MiddleItem>
            {businessNameActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        fontWeight="bold"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                    >
                        {businessName}:&nbsp;
                    </Typography>
                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                        {data.name}
                    </Typography>
                </DetailsTextItem>
            )}
            {addressActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        fontWeight="bold"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                    >
                        {address}:&nbsp;
                    </Typography>
                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                        {data.address}
                    </Typography>
                </DetailsTextItem>
            )}
            {telephoneActive && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        fontWeight="bold"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                    >
                        {telephone}:&nbsp;
                    </Typography>
                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                        {data.phone}
                    </Typography>
                </DetailsTextItem>
            )}
            {mobile && (
                <DetailsTextItem style={{ justifyContent: order, zIndex: 2 }}>
                    <Typography
                        variant="body2"
                        fontWeight="bold"
                        color={generateRgb(invoiceHeaderColor)}
                        fontSize={invoiceHeaderSize}
                    >
                        همراه:&nbsp;
                    </Typography>
                    <Typography variant="body2" color={generateRgb(invoiceBodyColor)} fontSize={invoiceBodySize}>
                        {data.mobile}
                    </Typography>
                </DetailsTextItem>

            )}
        </MiddleItem>
    );
};

const HandleDetails = ({
    data,
    values,
    value,
    order,
}: {
    data: any;
    values: typeof invoiceInitialValues;
    value: string;
    order: string;
}) => {
    const { logo } = values;

    const personData = {
        name: data?.Person?.nickName,
        address: `${data?.Person?.state ? data?.Person?.state + '-' : ''}${data?.Person?.city ? data?.Person?.city + '-' : ''} ${data?.Person?.address ? data?.Person?.address : ''}`,
        mobile: data?.Person?.mobile,
        phone: data?.Person?.phone,
        nameActive: values.cutomerBusinessNameActive,
        addresActive: values.customerAddressActive,
        telephoneActive: values.customerTelephoneActive,
    };

    // @ts-ignore
    const businessReducer = useSelector((state) => state).businessReducer;

    const business = businessReducer.business.business;

    const businessData = {
        name: business.nickName,
        address: `${business.state ? business.state : ''}- ${business.city ? business.city : ''} - ${business.address}`,
        mobile: business.mobile,
        phone: business.phone,
        nameActive: values.businessNameActive,
        addresActive: values.addressActive,
        telephoneActive: values.telephoneActive,
    };

    // const [searchParams, setSearchParams] = useSearchParams();
    // const factorType = searchParams.get("factorType");
    const factorType = data?.type;
    return (
        <>
            {value === "sellerInfo" && (
                <SellerDetails
                    data={factorType === "sale" ? businessData : personData}
                    values={values}
                    order={order}
                />
            )}
            {value === "customerInfo" && (
                <CustomerDetails
                    data={factorType === "sale" ? personData : businessData}
                    values={values}
                    order={order}
                />
            )}
            {value === "invoiceInfo" && <InvoiceDetail data={data} values={values} order={order} />}
            {value === "logo" && (
                <div
                    style={{
                        zIndex: 2,
                        textAlign: order === "center" ? "center" : order === "end" ? "end" : "start",
                    }}
                >
                    <Logo src={logo || DefaultPrintLogo} />
                </div>
            )}
            {value === "" && (
                <div
                    style={{
                        textAlign: order === "center" ? "center" : order === "end" ? "end" : "start",
                    }}
                />
            )}
        </>
    );
};

const SignImageContainer = styled("div")(
    ({ theme, backgroundImage }: { theme: ThemeObjType; backgroundImage: string }) => ({
        width: "200px",
        height: "50px",
        backgroundImage: `url("${backgroundImage}")`,
        backgroundSize: "100% 100%",
    })
);

const CustomPattern = ({ data }: { data: any }) => {
    const formikContext = useFormikContext();

    const { values } = formikContext as { values: typeof invoiceInitialValues };

    const backgroundColor = values?.backroundColor;

    //@ts-ignore
    const { paddingTop, paddingRight, paddingBottom, paddingLeft } = values;
    //@ts-ignore
    const { borderColor, borderSize, sign } = values;

    //@ts-ignore
    const { businessName, address, telephone, cutomerBusinessName, customerAddress, customerTelephone } =
        values;

    const {
        showAccountingCode,
        logo,
        showDate,
        invoiceHeaderColor,
        showDueDate,
        showSellerSign,
        showCustomerSign,
        showChortkeLogo,
        invoiceDetails,
    } = values;

    const factorTitle = () => {
        // return data?.title;
        let title;
        if (data?.status === "پیش نویس") {
            title = "پیش فاکتور";
        } else {
            switch (data?.type) {
                case "buy":
                    title = "فاکتور خرید";
                    break;
                case "buyReturn":
                    title = "فاکتور برگشت از خرید";
                    break;
                case "sale":
                    title = "فاکتور فروش";
                    break;
                case "saleReturn":
                    title = "فاکتور برگشت از فروش";
                    break;
                case "waste":
                    title = "فاکتور ضایعات";
                    break;
            }
        }
        return title;
    };

    useEffect(() => {
    }, [invoiceDetails]);

    return (
        <>
            {/* @ts-ignore */}
            {values?.header && <HeaderImage backgroundImage={values?.header} />}
            {/* @ts-ignore */}
            <BodyComponent
                //@ts-ignore

                backgroundColor={generateRgb(backgroundColor)}
                borderColor={generateRgb(borderColor)}
                borderSize={borderSize}
                paddingTop={paddingTop}
                paddingRight={paddingRight}
                paddingBottom={paddingBottom}
                paddingLeft={paddingLeft}
            //backgroundImage={values?.background}
            >
                <Box sx={{
                    backgroundImage: `url("${values?.background}")`,
                    position: 'absolute',
                    width: '100%',
                    bottom: 0,
                    height: values?.header ? "calc(100% - 50px)" : "100%",
                    zIndex: 1,
                    right: 0
                }}></Box>
                <TitleUpperSection >
                    <Typography sx={{ zIndex: 2 }} variant="h5" color={generateRgb(invoiceHeaderColor)} fontWeight="bold">
                        {factorTitle()}
                    </Typography>
                </TitleUpperSection>
                {invoiceDetails.map((item) => {
                    return (
                        // @ts-ignore
                        <RowItem key={shortid.generate()} items={item.columns.length}>
                            {item.columns.map((it, index) => {
                                return (
                                    <HandleDetails

                                        key={index}
                                        value={it.value}
                                        values={values}
                                        data={data}
                                        order={index === 0 ? "start" : index === item.columns.length - 1 ? "end" : "center"}
                                    />
                                );
                            })}
                        </RowItem>
                    );
                })}

                <TableComponent values={values} items={data?.Factor_Items} data={data} />
                {/* @ts-ignore */}
                <LowerSection data={data} values={values} />

                {showSellerSign ? (
                    <SignContainer sx={{ zIndex: 2 }}>
                        {showCustomerSign ? (
                            <SignComponent sx={{ zIndex: 2 }}>
                                {/* @ts-ignore */}
                                <SignImageContainer />
                                {/* <img style={{ width: '100', height: 'auto' }} src={customerSign} /> */}
                                <Typography sx={{ height: "50%", paddingTop: "10px" }}>
                                    محل امضا {["sale", "saleReturn"].includes(data?.type) ? "خریدار" : "فروشنده"}
                                </Typography>
                            </SignComponent>
                        ) : (
                            <div></div>
                        )}
                        <SignComponent sx={{ zIndex: 2 }}>
                            {/* @ts-ignore */}
                            <SignImageContainer backgroundImage={sign} />
                            <Typography sx={{ height: "50%", paddingTop: "10px" }}>
                                محل امضا {["sale", "saleReturn"].includes(data?.type) ? "فروشنده" : "خریدار"}
                            </Typography>
                        </SignComponent>
                    </SignContainer>
                ) : (
                    <></>
                )}
            </BodyComponent >
            {showChortkeLogo && (
                <InvoiceTag sx={{ zIndex: 2 }}>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <span>فاکتور طراحی شده با </span>
                        <img src={chortkeLogo} alt="logo" width={70} height={30} style={{ marginRight: 5 }} />
                    </div>
                    <div>www.Chortke.app</div>
                </InvoiceTag>
            )
            }
        </>
    );
};

const TableComponent = ({
    items,
    values,
    data,
}: {
    items: any[];
    values: typeof invoiceInitialValues;
    data: any;
}) => {
    const { showProductDescription, showDiscount, showTax, showProductcode, } = values;
    const bc: any = values.invoiceBodyColor;
    const hc: any = values.invoiceHeaderColor;
    const currency = data?.Currency?.en_title;

    const indexesToShow = [
        showProductcode,
        true,
        showProductDescription,
        true,
        true,
        showDiscount,
        showTax,
        true,
    ];
    return (
        <>
            <Table
                tableStyles={{ zIndex: 2 }}
                //noScroll
                headers={[
                    { label: "کد کالا" },
                    { label: "کالا/خدمات" },
                    { label: "توضیحات" },
                    { label: "مقدار/واحد" },
                    { label: "مبلغ واحد" },
                    { label: "تخفیف" },
                    { label: "مالیات" },
                    { label: "مبلغ کل" },
                ].filter((x, i) => indexesToShow[i])}
                cols={[
                    { Comp: Text, key: "code", getValue: (item: any) => item?.Product?.code },
                    {
                        Comp: Text,
                        key: "title",
                        getValue: (item: any) => item?.Product?.title,
                        // style: { maxWidth: 100, overflow: "hidden" },
                    },
                    { Comp: Text, key: "description" },
                    {
                        Comp: Text,
                        key: "quantity",
                        getValue: (item: any) => (
                            <div className="flex items-center justify-between gap-2">
                                <span className="text-dark-1 text-sm font-bold">{item.quantity}</span>
                                <span className="text-dark-3 text-xs">{item.unit}</span>
                            </div>
                        ),
                    },
                    { Comp: Price, key: "price", options: { currency } },
                    {
                        Comp: Text,
                        key: "discount",
                        getValue: (item: any) => formatPrice(item?.discount),
                    },
                    { Comp: Text, key: "tax", getValue: (item: any) => formatPrice(item?.tax) },
                    { Comp: Price, key: "totalOneProduct", options: { currency } },
                ].filter((x, i) => indexesToShow[i])}
                rows={items}
                withoutMenu
                headerColor="transparent"
                textColor={{
                    header: `rgba(${bc.r},${bc.g},${bc.b},${bc.a})`,
                    body: `rgba(${hc.r},${hc.g},${hc.b},${hc.a})`,
                }}
            />
        </>
    );
};

export default CustomPattern;
